import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { FormattedMessage, injectIntl, intlShape } from 'react-intl'
import { toInteger, isEmpty, map, toString } from 'lodash'

import { callApi } from '../services/fetchService'
import { getSelectOptions } from '../services/selectService'
import { loadGlobals } from '../actions'

import FaIcon from '../components/FaIcon'
import { Row, Col, Card, Form, Input, Button, Divider, Switch, Select, Spin, message } from 'antd'
const FormItem = Form.Item
const { TextArea } = Input



/**
 * Plant form inside the view
 */

class _PlantForm extends Component {

    static propTypes = {
        plant: PropTypes.object.isRequired,
        onSubmit: PropTypes.func.isRequired,
        intl: intlShape.isRequired
    }
    
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                this.props.onSubmit(values);
            }
        })
    }

    render() {
        const { getFieldDecorator } = this.props.form
        const { intl } = this.props

        const formItemLayout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 18 },
            style: { marginBottom: '10px' }
        }
        const switchLayout = {
            wrapperCol: { offset: 6, span: 18 },
            style: { marginBottom: '10px' }
        }
        const tailFormItemLayout = {
            wrapperCol: { offset: 6, span: 18 },
            style: { marginTop: '25px' }
        }
        
        return (
            <Row gutter={24}>
                <Col lg={14}>
                    <Card title={<span><FaIcon icon="info-circle" /><FormattedMessage id="plant.generalCard" /></span>}>
                        <Form layout="horizontal" onSubmit={this.handleSubmit}>
                            <FormItem label={<FormattedMessage id="plant.name" />} {...formItemLayout}>
                                {getFieldDecorator('name', {
                                    rules: [{required: true, message: intl.formatMessage({id: 'plant.nameRequired'})}]
                                })(<Input/>)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="plant.description" />} {...formItemLayout}>
                                {getFieldDecorator('description', {
                                    rules: [{required: true, message: intl.formatMessage({id: 'plant.descriptionRequired'})}]
                                })(<TextArea autosize={{ minRows: 4, maxRows: 10 }} />)}
                            </FormItem>
                            <FormItem label={<FormattedMessage id="plant.pharmaceuticalForms" />} {...formItemLayout}>
                                {getFieldDecorator('pharmaceuticalForms', {
                                    rules: [{required: true, message: intl.formatMessage({id: 'plant.pharmaceuticalFormsRequired'})}]
                                })(<Select showSearch mode="multiple" optionFilterProp="children" filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getSelectOptions('pharmaceutical-forms', this.props.plant.pharmaceuticalForms)}
                                </Select>)}
                            </FormItem>
                            <FormItem {...switchLayout}>
                                {getFieldDecorator('authorizedPregnancy', { valuePropName: 'checked' })(<Switch checkedChildren={<FaIcon icon="check" />} unCheckedChildren={<FaIcon icon="times" />} style={{ marginRight: '10px' }} />)}<FormattedMessage id="plant.authorizedPregnancy" />
                            </FormItem>
                            <FormItem {...switchLayout}>
                                {getFieldDecorator('authorizedBaby', { valuePropName: 'checked' })(<Switch checkedChildren={<FaIcon icon="check" />} unCheckedChildren={<FaIcon icon="times" />} style={{ marginRight: '10px' }} />)}<FormattedMessage id="plant.authorizedBaby" />
                            </FormItem>
                            <FormItem {...switchLayout}>
                                {getFieldDecorator('authorizedChild', { valuePropName: 'checked' })(<Switch checkedChildren={<FaIcon icon="check" />} unCheckedChildren={<FaIcon icon="times" />} style={{ marginRight: '10px' }} />)}<FormattedMessage id="plant.authorizedChild" />
                            </FormItem>
                            <Divider />
                            <FormItem {...tailFormItemLayout}>
                                <Button type="primary" loading={this.props.updating} htmlType="submit"><FormattedMessage id="misc.save" /></Button>
                            </FormItem>
                        </Form>
                    </Card>
                </Col>
                <Col lg={10}>
                    <Card title={<span><FaIcon icon="bullseye" /><FormattedMessage id="plant.actionsCard" /></span>}>
                        <Form layout="horizontal">
                            <FormItem>
                                {getFieldDecorator('actions')(<Select showSearch mode="multiple" style={{ width: '100%' }} optionFilterProp="children" placeholder={<FormattedMessage id="plant.actionsPlaceholder" />} filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getSelectOptions('actions', this.props.plant.actions)}
                                </Select>)}
                            </FormItem>
                        </Form>
                    </Card>
                </Col>
            </Row>
        )
    }

}

const PlantForm = injectIntl(Form.create({
    mapPropsToFields(props) {
        const actions = map(props.plant.actions, toString)  // Select works only with string keys
        return {
            name: Form.createFormField({value: props.plant.name}),
            description: Form.createFormField({value: props.plant.description}),
            authorizedPregnancy: Form.createFormField({value: props.plant.authorizedPregnancy}),
            authorizedBaby: Form.createFormField({value: props.plant.authorizedBaby}),
            authorizedChild: Form.createFormField({value: props.plant.authorizedChild}),
            pharmaceuticalForms: Form.createFormField({value: props.plant.pharmaceuticalForms}),
            actions: Form.createFormField({value: actions})
        };
    }
})(_PlantForm))



/**
 * User view
 */

class Plant extends Component {

    static propTypes = {
        history: PropTypes.object.isRequired,
        loadGlobals: PropTypes.func.isRequired,
        match: PropTypes.object.isRequired,
        intl: intlShape.isRequired
    }
    
    state = {
        plantId: null,
        plant: {},
        formPlant: {},
        loading: false,
        updating: false
    }

    fetch = () => {
        const { intl } = this.props
        this.setState({ loading: true })
        callApi({
            endpoint: 'plants/' + this.state.plantId
        }).then((data) => {
            this.setState({
                plant: data,
                formPlant: Object.assign({}, data),
                loading: false
            })
        }).catch((data) => {
            message.error(intl.formatMessage({id: 'misc.unknownError'}))
            this.setState({ loading: false })
        })
    }

    componentWillReceiveProps(nextProps) {
        let id = nextProps.match.params.id
        id = (id === undefined || id === null) ? null : toInteger(id)
        if (this.state.plantId !== id) {
            this.setState({ plantId: id }, () => {
                if (this.isNew()) {
                    this.setState({ plant: {}, formPlant: {} })
                } else {
                    this.fetch()
                }
            })
        }
    }

    componentWillMount() {
        let id = this.props.match.params.id
        id = (id === undefined || id === null) ? null : toInteger(id)
        this.setState({ plantId: id })
    }

    componentDidMount() {
        if (this.isNew()) {
            this.setState({ plant: {}, formPlant: {} })
        } else {
            this.fetch()
        }
    }

    savePlant = (plant) => {
        const { intl, history } = this.props
        this.setState({
            formPlant: Object.assign({}, this.state.formPlant, plant),
            updating: true
        })
        // Insert new
        if (this.isNew()) {
            callApi({
                endpoint: 'plants',
                body: plant,
                method: 'PUT'
            }).then((data) => {
                this.setState({
                    plantId: data.id,
                    plant: data,
                    formPlant: Object.assign({}, data),
                    updating: false
                })
                message.success(this.props.intl.formatMessage({id: "misc.insertSuccess"}))
                history.push('/plant/' + data.id)
                this.props.loadGlobals()
            }).catch((err) => {
                message.error(intl.formatMessage({id: 'misc.unknownError'}))
                this.setState({ updating: false })
            })
        }
        // Update
        else {
            callApi({
                endpoint: 'plants/' + this.state.plantId,
                body: plant,
                method: 'POST'
            }).then((data) => {
                this.setState({
                    plant: data,
                    formPlant: Object.assign({}, data),
                    updating: false
                })
                message.success(this.props.intl.formatMessage({id: "misc.updateSuccess"}))
                this.props.loadGlobals()
            }).catch((err) => {
                message.error(intl.formatMessage({id: 'misc.unknownError'}))
                this.setState({ updating: false })
            })
        }
    }

    isNew = () => {
        return this.state.plantId === null || this.state.plantId === undefined
    }

    render() {
        const { plant, loading, updating, formPlant } = this.state
      
		if (!this.isNew() && (isEmpty(plant) || loading)) {
			return (
                <div style={{ textAlign: 'center', marginTop: '50px' }}>
                    <Spin size="large" />
                </div>
            )
        }
        
        return (
            <div>
                {
                    this.isNew() ? <h1><FaIcon icon="leaf" fixedWidth /><FormattedMessage id="plant.titleNew"/></h1>
                    : <h1><FaIcon icon="leaf" fixedWidth /> <FormattedMessage id="plant.titleUpdate" values={plant} /></h1>
                }
                <PlantForm plant={formPlant} onSubmit={this.savePlant} updating={updating} />
            </div>
        )
    }

}

export default injectIntl(withRouter(connect(null, {
    loadGlobals
})(Plant)))


// WEBPACK FOOTER //
// ./src/views/Plant.js